import { Box, styled, Button, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { IOpsLinkMessage } from "@vmosolutions/oc-interfaces";
import RefreshIcon from "@mui/icons-material/Refresh";
import { refreshFlightEvents } from "src/redux/reducers/OpsLinkReducer";

interface IOpsLinkHeader {
  id: string;
  setCurrentEvent: React.Dispatch<React.SetStateAction<IOpsLinkMessage>>;
  clearFlights: () => void;
}

const OCOpsLinkHeader = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "100%",
  "& .rightHeader": {
    textAlign: "end",
  },
}));

export default function OpsLinkHeader(props: IOpsLinkHeader): JSX.Element {
  const { id, setCurrentEvent, clearFlights } = props;
  const dispatch = useDispatch();

  return (
    <OCOpsLinkHeader>
      <Grid container sx={{ alignItems: "center", height: "100%", padding: "10px" }}>
        <Grid item xs={6}>
          <Button size="small" onClick={clearFlights} color="primary" variant="contained" sx={{ cursor: "pointer" }}>
            Clear
          </Button>
        </Grid>
        <Grid item xs={6} className="rightHeader">
          <Button
            size="small"
            onClick={() => dispatch(refreshFlightEvents(true))}
            variant="contained"
            sx={{ minWidth: "40px", width: "40px", backgroundColor: "#666666" }}
          >
            <RefreshIcon />
          </Button>
          <Button
            size="small"
            onClick={() => setCurrentEvent(null)}
            variant="contained"
            color="success"
            sx={{ margin: "0 0 0 10px" }}
          >
            Create
          </Button>
        </Grid>
      </Grid>
    </OCOpsLinkHeader>
  );
}
